import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { IEndUserList } from '@components/onetoonemeetings';
import { ErrorHandler } from '@helper/errorHandler';

export const useEndUserListingQuery = (): IQueryResponse<IEndUserList[]> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('end_user_list');
	const fetchEndUserList = async (): Promise<IEndUserList[]> => {
		try {
			const response = await APIService.getData<IEndUserList[]>(APICONFIG.END_USER_LIST, {
				limit: '0',
			});
			if (response) {
				const data = response.map((item) => {
					return { ...item, id: item.id.toString() };
				});
				await setRxdb('end_user_list', data);
			}
			return response;
		} catch (error) {
			ErrorHandler(error);
			return [];
		}
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['enduserList'],
		queryFn: fetchEndUserList,
		enabled: isDbChecked && shouldFetch,
		retry: false,
		staleTime: 30 * 60 * 1000,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
